import creditRequestPrompt from "emun.invoice/credit-request/credit-request-prompt";
import BasicAutoQueryController from "servicestack/auto-query/auto-query.controller";
import modals from "webmodals/modals";
import retailerConfig from "emun.retailer/retailer.config";
import labels from "emun.invoice/credit-request/_labels";
import creditRequestConfig from "emun.invoice/credit-request/credit-request.config";

export const views = {
  list: "th-list",
  cards: "th",
};

export const filters = [
  { groupBy: "Status" },
  { date: "CreatedOn", title: "Date" },
];

export const sortOptions = {
  "RefId,Id": "Request Id: Low to High",
  "-RefId,Id": "Request Id: High to Low",
  "Status,Id": "Status: A to Z",
  "-Status,Id": "Status: Z to A",
  "InvoiceId,Id": "Invoice #: Low to High",
  "-InvoiceId,Id": "Invoice #: High to Low",
  //'GrandTotal,Id': 'Total: Low to High',
  //'-GrandTotal,Id': 'Total: High to Low',
  "CreatedOn,Id": "Date: Newest",
  "-CreatedOn,Id": "Date: Oldest",
};

export default class CreditRequestContainerController extends BasicAutoQueryController {
  constructor() {
    super();
    const $ctrl = this;
    $ctrl.config = retailerConfig;
    $ctrl.creditRequestConfig = creditRequestConfig;
    $ctrl.b2b = $ctrl.$state.current.name.indexOf("retailer.") > 0;
  }

  getQuery() {
    const $ctrl = this;
    console.debug($ctrl);
    return {
      url: "QueryCreditMemoRequests.json",
      pageSize: 12,
      orderBy: "-CreatedOn,Id",
      autoLoad: true,
      append: false,
      disableQueryString: true,
      filters,
      criteria: {
        RetailerId: $ctrl.retailerId,
        InvoiceId: $ctrl.invoiceId,
        ...($ctrl.criteria || {}),
      },
      hideLeftNav: true, // $ctrl.$pageConfig.is('gt-sm'),
      sortOptions,
    };
  }

  setStatus(request) {
    const $ctrl = this;
    $ctrl.bus.send("UpdateCreditMemoRequest.json", request).then(function () {
      //	$ctrl.$emit("creditRequestSaved", $ctrl);
      //	$ctrl.query.load(true);
    });
  }
  add() {
    const $ctrl = this;
  }
  edit(model) {
    const $ctrl = this;
    model.retailerId = $ctrl.retailerId;
    return creditRequestPrompt.edit(model).then(() => $ctrl.load(true));
  }
  delete(m) {
    const $ctrl = this;
    return modals
      .confirm("Are you sure?", "Delete " + labels.name)
      .result.then(function () {
        return $ctrl.bus
          .send("DeleteCreditMemoRequest", m)
          .then(function (response) {
            $ctrl.query.load(true);
          });
      });
  }
}
